import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { accountApi } from '../api/accountApi'
import { notify } from '@/shared/utils'

export function useAccount() {
  const queryClient = useQueryClient()

  const { data: account, isLoading } = useQuery({
    queryKey: ['account', 'me'],
    queryFn: accountApi.getMe,
  })

  const updateProfileMutation = useMutation({
    mutationFn: accountApi.updateProfile,
    onSuccess: (data) => {
      queryClient.setQueryData(['account', 'me'], data)
      notify.success('Profile updated')
    },
    onError: (error: Error) => {
      notify.error(error.message || 'Unable to save changes')
    },
  })

  const requestPhoneOtpMutation = useMutation({
    mutationFn: accountApi.requestPhoneChangeOtp,
    onSuccess: () => {
      notify.success('OTPs sent to both numbers')
    },
    onError: (error: Error) => {
      notify.error(error.message || 'Unable to send OTP')
    },
  })

  const verifyPhoneChangeMutation = useMutation({
    mutationFn: accountApi.verifyPhoneChange,
    onSuccess: (data) => {
      queryClient.setQueryData(['account', 'me'], data)
      notify.success('Phone number updated')
    },
    onError: (error: Error) => {
      notify.error(error.message || 'Unable to verify OTP')
    },
  })

  return {
    account,
    isLoading,
    updateProfile: updateProfileMutation.mutate,
    isUpdating: updateProfileMutation.isPending,
    requestPhoneOtp: requestPhoneOtpMutation.mutate,
    isRequestingOtp: requestPhoneOtpMutation.isPending,
    verifyPhoneChange: verifyPhoneChangeMutation.mutate,
    isVerifyingPhone: verifyPhoneChangeMutation.isPending,
  }
}
